import { Component, Inject } from '@angular/core';
import { APP_VARIABLES_TOKEN, AppVariables } from '@tablesready/frontend-variables';

@Component({
  selector: 'tablesready-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  constructor(
    @Inject(APP_VARIABLES_TOKEN) public readonly appVariables: AppVariables,
  ) {}
}
